import HeroBreakoutModule from './HeroBreakoutModule'

export default HeroBreakoutModule
